define(['app', './UserModel', 'utils/getWithInMemoryCache'], function (
  app,
  UserModel,
  cachedGet
) {
  cachedGet = cachedGet.default
  return app.Backbone.Collection.extend({
    url: '/member/_searchUser',
    comparator: function (model) {
      return model.get('name').toLowerCase()
    },
    sync: function (method, model, options) {
      return cachedGet(this.url, options)
    },
    model: UserModel
  })
})
